import React, { createContext } from 'react';
import { defaultSemModularRequest } from '~/constants/sem';
import type { SemId, SemLandingPageContent } from '~/contracts/sem';

type ContextType = {
  pageContent: SemLandingPageContent;
  semModularRequest: SemId;
  showFinance: boolean;
};

const defaultContext: ContextType = {
  pageContent: {
    id: 'default',
    modules: []
  },
  semModularRequest: defaultSemModularRequest,
  showFinance: false
};

const StaticContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<ContextType>;

export function StaticContextProvider({ children, ...props }: OwnProps) {
  return (
    <StaticContext.Provider value={props}>{children}</StaticContext.Provider>
  );
}

StaticContextProvider.displayName = 'StaticContextProvider';

export function useShowFinance() {
  return React.useContext(StaticContext).showFinance;
}

export default StaticContext;
